/// <amd-module name="InstantSearch/Shared/ResultRow" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";
import { Tooltip } from "VSSUI/TooltipEx";
import { WorkItemTrackingDataProvider, WorkItemTypeIconProvider } from "Wit/UI/Data";
import { WorkItemTypeIcon } from "Wit/UI/WorkItemTypeIcon";
import { IWorkItemTrackingDataProviderService } from "InstantSearch/Shared/Services/WorkItemTrackingDataProviderService";

export interface IIconAndClass {
    iconName: string;

    iconClass?: string;
}

export interface IWorkItemIconProps {
    project: string;

    workItemType: string;
}

export interface ResultRowProps {
    /**
     * Title of the result row
     */
    title: string;

    /**
     * Text in muted color, shown at the end of title
     */
    mutedText?: string;

    /**
     * Aria label for muted text shown at the end of title
     */
    mutedTextAriaLabel?: string;

    /**
     * If row is not for workitem result, provide iconProps and exclude workItemIconProps
     */
    iconProps?: IIconAndClass;

    /**
     * If row is for workitem result, provide workItemIconProps and exclude iconProps
     */
    workItemIconProps?: IWorkItemIconProps;
}

export class ResultRow extends VssComponent<ResultRowProps, {}> {
    private _workItemTrackingDataProvider: WorkItemTrackingDataProvider;

    public render(): JSX.Element {
        const { title, mutedText, mutedTextAriaLabel, iconProps, workItemIconProps } = this.props;

        return <div className={"search-suggestion-row flex-row flex-center"}>
            <span className="search-suggestion-icon flex-row flex-noshrink">
                {
                    iconProps &&
                    <Icon iconName={iconProps.iconName} className={iconProps.iconClass} />
                }
                {
                    workItemIconProps &&
                    <WorkItemTypeIconProvider
                        dataProvider={this.workItemTrackingDataProvider}
                        dataSource=
                        {
                            {
                                projectIdOrName: workItemIconProps.project,
                                workItemTypeName: workItemIconProps.workItemType
                            }
                        }>
                        {icon => <WorkItemTypeIcon data={icon} />}
                    </WorkItemTypeIconProvider>
                }
            </span>
            <Tooltip overflowOnly={true} text={title}>
                <span className="search-suggestion-title text-ellipsis">{title}</span>
            </Tooltip>
            {
                mutedText &&
                <span aria-label={mutedTextAriaLabel} className="muted-text">{mutedText}</span>
            }
        </div>

    }

    private get workItemTrackingDataProvider(): WorkItemTrackingDataProvider {
        if (!this._workItemTrackingDataProvider) {
            const workItemDataProviderService = this.context.pageContext.getService<IWorkItemTrackingDataProviderService>("IWorkItemTrackingDataProviderService");
            this._workItemTrackingDataProvider = workItemDataProviderService.getDataProvider();
        }

        return this._workItemTrackingDataProvider;
    }
}
